import React from 'react';
import { Image, RichText, mediaApi, withSitecoreContext } from '@sitecore-jss/sitecore-jss-react';
import css from './index.module.scss';

const hideImage = (e) => {
  e.target.setAttribute('data-visible', false);
}

const VideoInline = (props) => {
  const { fields, sitecoreContext } = props;
  const isEditing = sitecoreContext?.pageEditing;

  const maxWidthStyles = {
      paddingBottom: `${fields?.maxWidth?.value * .5625}px`,
      width: `${fields?.maxWidth?.value}px`
  }

  return (fields?.embedScript?.value || isEditing ?
      <>
      {
        fields?.embedScript?.value ?
        <section className={css.container} style={fields?.maxWidth?.value ? maxWidthStyles : {}}>
          <RichText field={fields.embedScript} className={css.script} />
          {
            fields?.image?.value?.src &&
            <div className={css.imageContainer} onClick={hideImage} style={{ backgroundImage: `url(${mediaApi.updateImageUrl(fields.image.value.src.split('?')[0])})` }}>
            </div>
          }
        </section>
        : fields ? <p>Add video embed to datasource to see it here.</p> : <p>Add and configure datasource to see VideoInline here.</p>
        }
        </>
      : null
  );
}

export default withSitecoreContext()(VideoInline);